/* import __COLOCATED_TEMPLATE__ from './client-block.hbs'; */
import { classNames } from '@ember-decorators/component';
import Super from './client-base';
import classic from 'ember-classic-decorator';
import styles from './client-block.module.scss';

@classic
@classNames(styles.component)
export default class RequestInformationClientBlock extends Super {}
